import { render, staticRenderFns } from "./basePacking.vue?vue&type=template&id=e8cce83a&"
import script from "./basePacking.vue?vue&type=script&lang=js&"
export * from "./basePacking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8cce83a')) {
      api.createRecord('e8cce83a', component.options)
    } else {
      api.reload('e8cce83a', component.options)
    }
    module.hot.accept("./basePacking.vue?vue&type=template&id=e8cce83a&", function () {
      api.rerender('e8cce83a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/basePacking.vue"
export default component.exports